// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap-R0sJBaie clearfix","list":"list-3J7Lw8D8"};